import React, {PropTypes} from 'react';
import classNames from 'classnames';

const Tag = ({name, hasSpacing, className, onClick, isSelected}) => {
  const cssClass = classNames({
    tag: true,
    'tag--has-spacing': hasSpacing,
    'tag--is-selected': isSelected,
  }, className);

  return (
    <a href={`/answers/tag/${name}`} className={cssClass} onClick={onClick}>
      {name}
    </a>
  );
};

Tag.propTypes = {
  name: PropTypes.string,
  hasSpacing: PropTypes.bool,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Tag;
